export default class Scroll {
    static scrollTo(to = window.pageYOffset, smooth, { left = 0, element = window } = {}) {
        const options = {
            left,
            top: to,
            behavior: smooth ? 'smooth' : 'auto',
        }

        if (!Scroll.supportsSmoothScroll) {
            element.scrollTo(...Object.values(options))
        } else {
            element.scrollTo(options)
        }
    }

    static get supportsSmoothScroll() {
        let supports = false
        try {
            const div = document.createElement('div')
            div.scrollTo({
                top: 0,
                get behavior() {
                    supports = true
                    return 'smooth'
                },
            })
        } catch {}
        return supports
    }
}
